
import './App.css';

import AllRouting from './Pages/AllRouting';

function App() {
  return (
    <div  className="App">
      <AllRouting />      
    </div>
  );
}

export default App;
